export default __webpack_public_path__ + "static/Hieu_Bui-5b9557d52c8005cc937670faef5a91e4.png";